import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import ChatWindow from './ChatWindow';
import api from '../../services/api';

const ChatButton = ({ orderId, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    checkUnread();
    const interval = setInterval(checkUnread, 10000);
    return () => clearInterval(interval);
  }, [orderId]);

  const checkUnread = async () => {
    try {
      const response = await api.get('/chat/conversations');
      const conversation = response.data.find(c => c.order_id === orderId);
      if (conversation) {
        setUnreadCount(conversation.unread_count || 0);
      }
    } catch (error) {
      console.error('Erro ao verificar mensagens:', error);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsOpen(true)}
        className={`relative ${className}`}
      >
        <MessageCircle className="w-4 h-4 mr-2" />
        Chat
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </Button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
          <div className="w-full max-w-md">
            <ChatWindow orderId={orderId} onClose={() => setIsOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
};

export default ChatButton;
